import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { getIsAllowedPermission } from "../Helper";

export  function usePermission(
  permissionsList,
  permissionsId,
  allowEmptyRoles = false
) {
  const loginResponse = useSelector((state) => state.login.loginResponse);
  const isAllowed = useMemo(
    () =>
      getIsAllowedPermission(
        permissionsList,
        loginResponse,
        permissionsId,
        allowEmptyRoles
      ),
    [permissionsList, loginResponse, permissionsId, allowEmptyRoles]
  );

  return { isAllowed };
}
